import React from 'react';
import { AppThunk } from 'store/store';
import { NotificationId } from 'features/notifications/types';
import { JOIN_NOTIFICATION_CONTAINER_ID } from 'features/notifications/constants';
import { notification } from 'features/notifications/toast/notification';
import { selectIsSystemSession } from 'features/application/selectors';
import JoinNotificationTemplate from 'features/notifications/join-screen-notifications/JoinNotificationTemplate';
import { ToastOptions } from 'react-toastify';
import { selectGlobalUser } from 'features/users/usersSlice';
import { EventUser } from 'services/signaling';

// @TODO bring logic from updateActionNotification if we need Redux control
export const updateJoinNotification =
  (
    id: NotificationId,
    params: {
      initiator?: EventUser;
      content?: React.ReactNode;
      scope?: string[];
      initiatorId?: string;
    },
    toastOptions?: ToastOptions
  ): AppThunk<void | NotificationId> =>
  (dispatch, getState) => {
    const isSystemSession = selectIsSystemSession(getState());
    if (isSystemSession) {
      return undefined;
    }

    const props = params;
    const initiator = selectGlobalUser(getState(), params.initiator?.id || '') || props.initiator;

    notification.update(id, {
      render: ({ data, ...toastContentProps }) => (
        <JoinNotificationTemplate {...toastContentProps} initiator={initiator} {...props} id={id} />
      ),
      ...toastOptions,
      containerId: JOIN_NOTIFICATION_CONTAINER_ID,
    });
  };
